import type { FetchOptions } from 'ofetch';
import { $fetch, } from 'ofetch';
import CollectionModule from '~/repository/modules/collection';
import IndexModule from '~/repository/modules/index';
import MissionsModule from '~/repository/modules/missions';
import PaymentModule from '~/repository/modules/payment';
import SocialModule from '~/repository/modules/social';
import TicketsModule from '~/repository/modules/tickets';
import UserModule from '~/repository/modules/user';

interface IApiInstance {
  index: IndexModule;
  missions: MissionsModule;
  user: UserModule;
  social: SocialModule;
  collection: CollectionModule;
  payment: PaymentModule;
  tickets: TicketsModule;
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  const fetchOptions: FetchOptions = {
    baseURL: config.public.baseURL,
    headers: {
      'Accept-Language': 'tr',
      'Content-Type': 'application/json',
    }
  };

  // Create a new instance of $fecther with custom option
  const apiFecther = $fetch.create(fetchOptions);

  // An object containing all repositories we need to expose
  const modules: IApiInstance = {
    index: new IndexModule(apiFecther),
    missions: new MissionsModule(apiFecther),
    user: new UserModule(apiFecther),
    social: new SocialModule(apiFecther),
    collection: new CollectionModule(apiFecther),
    payment: new PaymentModule(apiFecther),
    tickets: new TicketsModule(apiFecther),
  };

  return {
    provide: {
      api: modules
    }
  };
});
